<template>
  <Select
    v-model="localValue"
    :mandatory="!$attrs.clearable"
    v-bind="$attrs"
    :items="items"
  >
    <!-- Pass through all slots -->
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>

    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </Select>
</template>

<script>
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  props: {
    trueText: {
      type: String,
      default: 'general.yes',
    },
    falseText: {
      type: String,
      default: 'general.no',
    },
    nullText: {
      type: String,
      default: 'general.all',
    },
  },
  computed: {
    items() {
      let items = [];

      if (!this.$attrs.clearable) {
        items.push({ text: this.$t(this.nullText), value: null });
      }

      items.push(
        { text: this.$t(this.trueText), value: true },
        { text: this.$t(this.falseText), value: false }
      );
      return items;
    },
  },
};
</script>

<style lang="scss" scoped></style>
